module.exports = __webpack_public_path__ + "img/banner.eb3c9a1a.png";